import gqlRequest from 'graphql/generic';
import { NewBuyerSellerType, NewOrderPartyType } from 'types/order';

type updatePartyOrderDataReturn = {
  updateOrderSpecifics: {
    parties: NewOrderPartyType[];
  };
};

const updatePartyOrderData = `
  mutation UpdateOrderSpecifics($id: ID!, $partyId: ID, $dataBuyer: OrderPartyBuyerContent, $dataSeller: OrderPartySellerContent) {
    updateOrderSpecifics(_id: $id, party_id: $partyId, data_buyer: $dataBuyer, data_seller: $dataSeller) {
       parties {
        _id
        name
        associations {
          linked_as
          party_id
          party_kind
          party_name
        }
        kinds
        member_of {
          _id
          kind
          name
        }
        order_data {
          ... on OrderPartyBuyer {
            acknowledgement
            declines_ssn_ein
            exception_1099
            gross_proceeds
            include_marital
            include_vesting
            is_foreign
            jurat
            kind
            kind_owner
            listed_on_title
            name_control
            ownership
            part_of_tax
            vesting
            vesting_block {
              kind
              text
              tabs
            }
            vesting_type
          }
          ... on OrderPartyExchange1031 {
            exchange_1031
            kind
          }
          ... on OrderPartySeller {
            acknowledgement
            declines_ssn_ein
            exception_1099
            gross_proceeds
            include_marital
            include_vesting
            is_foreign
            jurat
            kind
            kind_owner
            listed_on_title
            name_control
            ownership
            part_of_tax
            vesting
            vesting_block {
              kind
              text
              tabs
            }
            vesting_type
          }
          ... on OrderPartyPowerOfAttorney {
            end_date
            kind
            start_date
          }
        }
      }
    }
  }
`;

type updatePartyOrderDataParams = {
  id: string;
  partyId: string;
  dataBuyer?: NewBuyerSellerType;
  dataSeller?: NewBuyerSellerType;
};

export const mutationUpdatePartyOrderData = (params: updatePartyOrderDataParams) =>
  gqlRequest<updatePartyOrderDataReturn, updatePartyOrderDataParams>(updatePartyOrderData, params);

type deleteAssociationReturn = {
  deleteOrderAssociation: {
    parties: NewOrderPartyType[];
  };
};

const deleteAssociationQuery = `
  mutation DeleteOrderAssociation($id: ID!, $partyId: ID!, $kind: String, $linkedToId: String) {
    deleteOrderAssociation(_id: $id, party_id: $partyId, kind: $kind, linked_to_id: $linkedToId) {
      parties {
        _id
        name
        associations {
          parent
          linked_as
          party_id
          party_kind
          party_name
        }
        kinds
        member_of {
          _id
          kind
          name
        }
        order_data {
          ... on OrderPartyBuyer {
            acknowledgement
            declines_ssn_ein
            exception_1099
            gross_proceeds
            include_marital
            include_vesting
            is_foreign
            jurat
            kind
            kind_owner
            listed_on_title
            name_control
            ownership
            part_of_tax
            vesting
            vesting_block {
              kind
              text
              tabs
            }
            vesting_type
          }
          ... on OrderPartyExchange1031 {
            exchange_1031
            kind
          }
          ... on OrderPartySeller {
            acknowledgement
            declines_ssn_ein
            exception_1099
            gross_proceeds
            include_marital
            include_vesting
            is_foreign
            jurat
            kind
            kind_owner
            listed_on_title
            name_control
            ownership
            part_of_tax
            vesting
            vesting_block {
              kind
              text
              tabs
            }
            vesting_type
          }
          ... on OrderPartyPowerOfAttorney {
            end_date
            kind
            start_date
          }
        }
      }
    }
  }
`;

type deleteAssociationParams = {
  id: string;
  partyId: string;
  kind: string;
  linkedToId: string;
};

export const GQLDeleteAssociation = (params: deleteAssociationParams) =>
  gqlRequest<deleteAssociationReturn, deleteAssociationParams>(deleteAssociationQuery, params);
